import React, { useState } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { urtoast } from "../../Layouts/CustomPopup/eventEmitter";
import { PostChat } from "../../../redux/chatandnotification/action";
import { useDispatch } from "react-redux";
import LoginLoaderButton from "../Loader/LoginLoaderButton";
import CompanyFileUpload from "../../Modules/ExpertCompanyRegistration/DifferentFlow/CompanyFlow/CompanyFileUpload";
import { titlevalidation } from "../commonvalidation";

// Validation Schema for Formik
const validationSchema = Yup.object().shape({
  files: Yup.array()
    .of(
      Yup.object().shape({
        file: Yup.mixed().required("File is required"),
      }),
    )
    .required("Files are required")
    .min(1, "At least one file is required"),
  // message: titlevalidation,
});



const MultipleFileUploadForFiles = ({ setfileModel, id1, id2, posts, type }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const initialValues = {
    message: "",
    files: [],
  };

  const handleSubmit = async (values, actions) => {
    console.log(values, 'values');
    const imagesPayload = Array.isArray(values?.files) && values?.files?.map(file => ({
      image: file.file, // use file URL
    })) || [];


    setLoading(true);

    try {
      const data = {
        type,
        user_id: (type == "2" || type == "3") ? id1 : (posts?.is_mine == 1 ? id1 : id2 || id1),
        post_id: (type == "2" || type == "3") ? "" : posts?.id || "",
        message: values.message,
        image: imagesPayload,
      };

      dispatch(PostChat(data, setLoading));
      setfileModel(false); // Close the file modal
    } catch (error) {
      urtoast(error.message, 2);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize={true}
      >
        {(formik) => (
          <Form>
            <div>
              <CompanyFileUpload formik={formik} name={"files"} />
              <div>
                <label htmlFor="message">Message</label>
                <input
                  type="text"
                  name="message"
                  value={formik.values.message}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="form-control"
                  placeholder="Enter message"
                />
                <ErrorMessage name="message" component="div" className="error" />
              </div>

              <br />

              <button
                disabled={loading}
                onClick={formik.handleSubmit}
                className="btn w-100 submit-req"
              >
                {loading ? <LoginLoaderButton /> : "SEND"}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default MultipleFileUploadForFiles;
